module.exports = __webpack_public_path__ + "img/adModel3.67bb5bc2.png";